import styled from 'styled-components'

import {Box, Button, ListItem, ModalFooter, Text, tokens} from '@pleo-io/telescope'

import {Grid, GridItem} from '@product-web/telescope-lab/grid'

import {breakpoints} from 'styles/theme'

import PlanBenefitsList from './plan-benefits-list'
import trophyIconSrc from './trophy.svg'

export const ListWrapper = styled.div`
    max-width: 300px;
    display: flex;
    flex-direction: column;
`

export const StyledBenefitsList = styled(PlanBenefitsList)`
    flex-grow: 1;
`

export const ListItemLight = styled(ListItem)`
    color: ${tokens.shade800};
    font-weight: ${tokens.fontWeightMedium};
    font-size: ${tokens.fontSmall};
    display: flex;

    &:last-child {
        margin-bottom: ${tokens.spacing4};
    }

    @media (max-height: ${breakpoints.tabletMedUp}) {
        margin-bottom: ${tokens.spacing8};
    }
`

export const StretchGrid = styled(Grid)`
    align-items: stretch;
`

export const StretchGridItem = styled(GridItem)``

export const BoxedItem = styled.div`
    width: 100%;
    height: 100%;
    min-height: 300px;
    box-sizing: border-box;
    padding: ${tokens.spacing32};
    text-align: left;
    border: ${tokens.borderPrimary};
    border-radius: ${tokens.arc8};
    transition: ${tokens.fastInOut};
`

export const BoxedItemHighlighted = styled(BoxedItem)`
    margin-top: 0;
    border-color: ${tokens.shade800};
    box-shadow: ${tokens.shadowRaise};
`

export const ButtonCenter = styled(Button)`
    text-align: center;
    width: 100%;
    margin-top: auto;
    border-color: ${tokens.shade300};

    &:disabled {
        color: ${tokens.shade800};
    }
`

export const ChangePlanButtonBox = styled(Box)`
    margin-top: ${tokens.spacing16};
    padding-bottom: ${tokens.spacing24};
    height: 40px;
    display: flex;
`

export const YellowBox = styled(Box)`
    background-color: ${tokens.yellow200};
    padding: 8px 12px;
`

export const ModalWrapper = styled.div`
    padding-bottom: ${tokens.spacing24};
`

export const ModalHeader = styled.div`
    padding-top: ${tokens.spacing40};
    padding-bottom: ${tokens.spacing28};
    text-align: center;
    border-radius: ${tokens.arc8} ${tokens.arc8} 0 0;

    @media (max-height: ${breakpoints.tabletMedUp}) {
        padding-top: ${tokens.spacing24};
    }
`

export const ModalLink = styled(Button).attrs({variant: 'link'})`
    font-size: ${tokens.fontSmall};
`

interface PlanTitleProps {
    shouldOverflow: boolean | undefined
}

export const PlanTitleWrapper = styled(Text)<PlanTitleProps>`
    position: relative;
    height: ${(props) => (!props.shouldOverflow ? '120px' : '140px')};
`

export const HeaderText = styled(Text).attrs({color: 'colorContentStatic', weight: 'medium'})`
    margin-bottom: ${tokens.spacing16};
`

export const DiscountText = styled(Text)`
    text-decoration: line-through;
    font-size: ${tokens.fontXLarge};
`

export const RecommendedPlanIcon = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    width: ${tokens.spacing36};
    height: ${tokens.spacing36};
    background-image: url(${trophyIconSrc});
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
`

export const ModalFooterContainer = styled(ModalFooter)`
    background-color: ${tokens.shade100};
`

export const PlanPillBox = styled.div`
    display: flex;
    align-items: center;
`

export const PlanPill = styled(Text)`
    background-color: ${tokens.shade300};
    text-transform: uppercase;
    padding: 0 ${tokens.spacing6};
    display: flex;
    align-items: center;
`

export const PricingText = styled(Text)`
    display: flex;
    flex-direction: row;
    align-items: baseline;
    gap: 8px;
`

export const BillingText = styled(Text)`
    margin-top: ${tokens.spacing16};
`

export const CashbackText = styled(Text)`
    margin-bottom: ${tokens.spacing16};
    color: ${tokens.pink800};

    span {
        margin-left: ${tokens.spacing8};
    }
`
